import './App.css';
import React, { useState, useEffect } from "react";
import axios from "axios";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SubscribeForm from "./routes/SubscribeForm";
import StartupForm from "./routes/StartupForm";
import CoeurForm from "./routes/CoeurForm";
import BloomForm from "./routes/BloomForm";
import RocketForm from "./routes/RocketForm";
import MainLayout from "./routes/MainLayout";
import ConfirmEmail from './routes/ConfirmEmail';
import ReferralCode from './routes/ReferralCode';
import BoardPart1 from './routes/OnBoard'
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe("REACT_APP_STRIPE_PUBLISHABLE_KEY");

function App() {
  return (
    <Router>
      <Elements stripe={stripePromise}>
        <div className="App">
          <Routes>
            <Route element={<MainLayout />}>
              <Route path="/" element={<SubscribeForm />} />
              <Route path="/:referralCode" element={<SubscribeForm />} />
              <Route path="/referral/:token" element={<ReferralCode />} />
              <Route path="/email-confirmation/:token" element={<ConfirmEmail />} />
              <Route path="/launchpad360signup" element={<StartupForm />} />
              <Route path="/launchpad360signup/:referralCode" element={<StartupForm />} />
              <Route path="/coeur360signup" element={<CoeurForm />} />
              <Route path="/coeur360signup/:referralCode" element={<CoeurForm />} />
              <Route path="/bloom360signup" element={<BloomForm />} />
              <Route path="/bloom360signup/:referralCode" element={<BloomForm />} />
              <Route path="/rocket360signup" element={<RocketForm />} />
              <Route path="/rocket360signup/:referralCode" element={<RocketForm />} />
              <Route path="/Join360" element={<BoardPart1 />} />
              <Route path="/*" element={<Navigate to="/" />} />
            </Route>
            <Route path="/static" element={<SubscribeForm />} />
          </Routes>
        </div>
      </Elements>
    </Router>
  );
}

export default App;
